import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const subtitles = [
  "Nurturing Excellence, Building Character",
  "Where Education Meets Excellence",
  "Shaping Tomorrow's Leaders Today",
  "A Legacy of Learning and Growth",
  "Empowering Minds, Enriching Lives"
];

const AnimatedSubtitle: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % subtitles.length);
    }, 3000); // Change subtitle every 3 seconds (slightly longer than title)

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-16 flex items-center justify-center overflow-hidden">
      <AnimatePresence mode="wait">
        <motion.h2
          key={currentIndex}
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -20, opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="text-2xl lg:text-3xl font-semibold text-slate-700 max-w-2xl"
        >
          {subtitles[currentIndex]}
        </motion.h2>
      </AnimatePresence>
    </div>
  );
};

export default AnimatedSubtitle; 